/* eslint-disable import/prefer-default-export */

export function cardImageSize(itemSize) {
  if (itemSize.includes('solo')) {
    return '(min-width: 480px) 50vw, 100vw'
  }
  if (itemSize.includes('fit')) {
    return '(min-width: 1024px) 464px, (min-width: 360px) 50vw, 60vw'
  }
  if (itemSize.includes('half')) {
    return '(min-width: 1024px) 464px, (min-width: 600px) 50vw, 60vw'
  }
  if (itemSize.includes('categories')) {
    return '(min-width: 768px) 33vw, (min-width: 1124px) 25vw, 50vw'
  }
  if (itemSize.includes('third')) {
    return '(min-width: 1024px) 295px, (min-width: 600px) 33vw, 60vw'
  }
  return '100vw'
}

export function imgArea(dim) {
  return dim.split('x').reduce((w, h) => w * h)
}
